import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getOrder, GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { getOrderFromERP } from "@tKgpco/Services/ERPOrderService";
import loadOrderLinesDetails from "@tKgpco/Store/Data/OrderHistoryDetail/Handlers/LoadOrderLinesDetails";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[] },
    GetOrderApiParameter,
    OrderModel
>;

export const DispatchBeginLoadOrder: HandlerType = props => {
    props.dispatch({
        type: "Data/Orders/BeginLoadOrder",
        orderNumber: props.parameter.orderNumber,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        expand: props.parameter.expand ?? ["orderLines", "shipments"],
    };
    props.dispatch({
        type: "Custom/Orders/ResetLoadOrderDetailsLine",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getOrderFromERP(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 404 || error.status === 403)) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadOrder: HandlerType = props => {
    const order = props.apiResult;
    props.dispatch({
        type: "Data/Orders/CompleteLoadOrder",
        model: props.apiResult,
    });

    if (order?.orderLines?.length) {
        const totalLines = order.orderLines.length;
        const pageSize = 100; // each page has 100 lines
        const totalPages = Math.ceil(totalLines / pageSize);

        for (let page = 1; page <= totalPages; page++) {
            props.dispatch(
                loadOrderLinesDetails({
                    orderNumber: order.erpOrderNumber || order.webOrderNumber,
                    pageNumber: String(page),
                    currentDateTime: new Date().toString(),
                }),
            );
        }
    }
};

export const chain = [DispatchBeginLoadOrder, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadOrder];

const LoadOrderByOrderNumberERP = createHandlerChainRunner(chain, "LoadOrderByOrderNumberERP");
export default LoadOrderByOrderNumberERP;
